/**
 * Identity of the session whose events the WebSocketProvider holds: null
 * while disabled (logged out), otherwise the user id. Per-user state (task
 * progress, unread count, latest notification, credit update) is reset
 * whenever this changes, so a logout -> login as someone else in the same
 * tab never shows the previous user's data (FE-20).
 */
export function websocketSessionKey(disabled: boolean, userKey?: string | number | null): string | null {
  return disabled ? null : `user:${userKey ?? ''}`;
}

/** Whether moving from `prev` to `next` must drop per-user state. */
export function shouldResetWebsocketSession(prev: string | null, next: string | null): boolean {
  return prev !== next;
}
